import { Component, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericButton } from '@models/models';

@Component({
	selector: 'confirm-general-modal',
	template: require('./confirm-general-modal.component.html'),
	styles: [require('./confirm-general-modal.component.scss')]
})
export class ConfirmGeneralModalComponent {
	@Input() title?: string;
	@Input() text: string;
	@Input() buttons: Array<GenericButton>;

	constructor(private ngbActiveModal: NgbActiveModal) {}

	closeWithAction(action: string): void {
		this.ngbActiveModal.close(action);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.ts